import classes from "./Loading.module.css";
import { InfinitySpin } from "react-loader-spinner";
function Loading() {
  return (
    <div className={classes.modal}>
      <div className={classes.content}>
        <InfinitySpin color="grey" />
      </div>
    </div>
  );
}

export default Loading;
